module.exports = __webpack_public_path__ + "img/Applied_Material.5fa151f8.svg";